import type { AppLocale } from '@duvamarine/i18n';
import {
  formatMoney,
  minorToMajorString,
  MoneyError,
  parseMajorToMinor,
  type Currency,
} from '@duvamarine/shared';
import { INTL_LOCALES } from './date-locales';

/* Money in admin forms: major-unit strings in inputs, integer minor units on the wire. */

export function formatAmount(amountMinor: number, currency: Currency, locale: AppLocale): string {
  return formatMoney({ amountMinor, currency }, INTL_LOCALES[locale]);
}

export function toMajorInput(amountMinor: number | null | undefined, currency: Currency): string {
  return amountMinor === null || amountMinor === undefined
    ? ''
    : minorToMajorString(amountMinor, currency);
}

/** "" → null; invalid → undefined (the caller shows `validation.number`). */
export function fromMajorInput(value: string, currency: Currency): number | null | undefined {
  const text = value.trim();
  if (!text) return null;
  try {
    return parseMajorToMinor(text, currency);
  } catch (error) {
    if (error instanceof MoneyError) return undefined;
    throw error;
  }
}

/** "12,5" (percent) → 1250 bps; "" → null; invalid → undefined. */
export function percentToBps(value: string): number | null | undefined {
  const text = value.trim().replace(',', '.');
  if (!text) return null;
  const number = Number(text);
  return Number.isFinite(number) ? Math.round(number * 100) : undefined;
}

export function bpsToPercent(bps: number | null | undefined): string {
  return bps === null || bps === undefined ? '' : String(bps / 100);
}

/** "" → null; non-integers → undefined. */
export function toInteger(value: string): number | null | undefined {
  const text = value.trim();
  if (!text) return null;
  const number = Number(text);
  return Number.isInteger(number) ? number : undefined;
}
